import { render, staticRenderFns } from "./BankAccoun.vue?vue&type=template&id=22e8edab&scoped=true"
import script from "./BankAccoun.vue?vue&type=script&lang=js"
export * from "./BankAccoun.vue?vue&type=script&lang=js"
import style0 from "./BankAccoun.vue?vue&type=style&index=0&id=22e8edab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8edab",
  null
  
)

export default component.exports